import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import FormButton from "components/buttons/FormButton";
import ModalTasksSelect from "site-apps/maintenance/tasks/ModalTasksSelect";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";

const FormOrders = ({item, setItem, setShowCanvas, showCanvas, fetchTasks, leaderOptions = [], ChoicesStatus = {}, ChoicesOrigin = {}}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [isLoading, setIsLoading] = useState(false);
    const [showModalTasks, setShowModalTasks] = useState(false);
    const inputRefs = useRef({});

    useEffect(() => {
        return () => {
            unsubscribeEvent("tasks:modalselect:change", eventChangeTasks);
        };
    }, []);

    const handleOpenTaskSelector = () => {
        setShowModalTasks(true);
        subscribeEvent("tasks:modalselect:change", eventChangeTasks);
    };

    const eventChangeTasks = (e) => {
        const result = Array.isArray(e.detail) ? e.detail[0] : e.detail;
        if (result) {
            let it = {...item};
            it.task_data = {id: result.id, name: result.name};
            setItem(it);
        }
        unsubscribeEvent("tasks:modalselect:change", eventChangeTasks);
        setShowModalTasks(false);
    };

    const handleClose = () => setShowCanvas(false);

    const handleChange = (e) => {
        const {name, type} = e.target;
        const value = type === "checkbox" ? e.target.checked : e.target.value;
        let it = {...item};
        it[name] = value;
        setItem(it);
    };

    const handleSubmit = () => {
        if (!item) return;
        setIsLoading(true);

        const payload = {
            id: item.id || null,
            task_id: item.task_data?.id || null,
            programming_id: item.programming_data?.id || null,
            scheduled_at: item.scheduled_at || null,
            status: item.status || null,
            origin: item.origin || null,
            description: item.description || "",
            leader: item.order_leader_email || "",
        };

        axiApi
            .post("/api/maint/orders/add/", payload)
            .then((resp) => {
                if (resp.data && resp.data.status) {
                    if (typeof fetchTasks === "function") fetchTasks();
                    setShowCanvas(false);
                    Alert.info("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.error("Error al guardar", resp.data?.message || "Consultar con el administrador");
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.error("Error servidor", "Consultar con el administrador");
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <Offcanvas
            show={showCanvas}
            onHide={handleClose}
            placement="end"
            backdrop="static"
            style={{width: "40%", fontSize: "15px"}}>
            <Offcanvas.Header className="preview-canvas">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="wrench" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>{_Tr("labels.orders")}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                <div className="container-fluid">
                    <div className="row g-3 mb-5 pb-5">
                        <div className="col-12">

                            <div className="row g-3 align-items-center">
                                <div className="col-3">
                                    <label className="col-form-label">Tarea</label>
                                </div>
                                <div className="col-9">
                                    <div className="input-group">
                                        <input type="text" readOnly className="form-control" value={item.task_data?.name || ""} />
                                        <button type="button" className="btn btn-outline-primary" onClick={handleOpenTaskSelector} title="Seleccionar tarea">
                                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Programación</label>
                                </div>
                                <div className="col-9">
                                    <input type="text" readOnly className="form-control" value={item.programming_data?.name || ""} />
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Incidencia</label>
                                </div>
                                <div className="col-9">
                                    <input type="text" readOnly className="form-control" value={item.incidence_data?.name || ""} />
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Programada</label>
                                </div>
                                <div className="col-9">
                                    <input type="datetime-local" name="scheduled_at" value={item.scheduled_at ? item.scheduled_at.replace('Z','') : ''} onChange={handleChange} className="form-control" />
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Estado</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select name="status" value={item.status || ''} onChange={handleChange} style={{maxWidth: "160px"}}>
                                        <option value="">--</option>
                                        {Object.keys(ChoicesStatus).map((k) => (
                                            <option key={k} value={k}>{ChoicesStatus[k]}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Origen</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select name="origin" value={item.origin || ''} onChange={handleChange} style={{maxWidth: "160px"}}>
                                        <option value="">--</option>
                                        {Object.keys(ChoicesOrigin).map((k) => (
                                            <option key={k} value={k}>{ChoicesOrigin[k]}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Responsable (orden)</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select name="order_leader_email" value={item.order_leader_email || ''} onChange={handleChange}>
                                        <option value="">— Sin responsable —</option>
                                        {leaderOptions.map((opt) => (
                                            <option key={opt.value} value={opt.value}>{opt.value}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Descripción</label>
                                </div>
                                <div className="col-9">
                                    <textarea className="form-control" rows={3} name="description" value={item.description || ''} onChange={handleChange} />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {showModalTasks ? (
                    <ModalTasksSelect show={showModalTasks} setShow={setShowModalTasks} multiple={false} chosenIn={item.task_data?.id ? [item.task_data] : []} subtitle={document.title} />
                ) : (
                    <></>
                )}
                <div className="p-3 buttons-footer">
                    <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {_Tf("labels.cancel")}
                        </button>
                        <FormButton
                            label="Guardar"
                            className="btn btn-primary ms-4"
                            isProcessing={isLoading}
                            onClick={handleSubmit}>
                            {_Tf("labels.save")}
                        </FormButton>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormOrders;
